var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V12C11.25 12.4142 11.5858 12.75 12 12.75C12.4142 12.75 12.75 12.4142 12.75 12V2ZM8.33377 5.60718C8.70471 5.42284 8.85597 4.97271 8.67164 4.60177C8.4873 4.23084 8.03716 4.07957 7.66623 4.26391C4.45765 5.85844 2.25 9.17073 2.25 13C2.25 18.3848 6.61522 22.75 12 22.75C17.3848 22.75 21.75 18.3848 21.75 13C21.75 9.17073 19.5423 5.85844 16.3338 4.26391C15.9628 4.07957 15.5127 4.23084 15.3284 4.60177C15.144 4.97271 15.2953 5.42284 15.6662 5.60718C18.3845 6.95806 20.25 9.76188 20.25 13C20.25 17.5564 16.5563 21.25 12 21.25C7.44365 21.25 3.75 17.5564 3.75 13C3.75 9.76188 5.61547 6.95806 8.33377 5.60718Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.4d61765ba7812c59444bd4148efdb80a.svg";
export { ForwardRef as ReactComponent };